import React from "react";

interface FunnelFilterIconProps {
  className?: string;
  onClick?: () => void;
}

export const FunnelFilterIcon = ({
  className,
  onClick,
}: FunnelFilterIconProps) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <circle
      cx="17"
      cy="3"
      r="3"
      fill="#0344DC"
      stroke="#FFFFFF"
      strokeWidth="1"
    />
    <path
      d="M17.0312 2.04688C17.4688 2.04688 17.7708 2.25521 17.9375 2.67188C18.125 3.08854 18.0625 3.45312 17.75 3.76562L12.0312 9.45312V17.0469C12.0312 17.4844 11.8333 17.7865 11.4375 17.9531C11.0417 18.1406 10.6875 18.0885 10.375 17.7969L8.375 16.0469C8.14583 15.8594 8.03125 15.6094 8.03125 15.2969V9.45312L2.3125 3.76562C2 3.45312 1.92708 3.08854 2.09375 2.67188C2.28125 2.25521 2.59375 2.04688 3.03125 2.04688H17.0312ZM11.0312 9.04688L17.0312 3.04688H3.03125L9.03125 9.04688V15.2969L11.0312 17.0469V9.04688Z"
      fill="#0344DC"
    />
  </svg>
);

FunnelFilterIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
